import type { FaireProductEntity } from "../../entity_types/product";

export const p_8sx4wk8ywe: FaireProductEntity = {
  token: "p_8sx4wk8ywe",
  type: "product",
  name: "Anywhere Towel -  RJW Glitz",
  brandToken: "b_ci67w2i6k6",
  brandName: "Once Again Home Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/6cb76512739de9058804e11abe473454bd4ab560be8e51433f195b8c35ed0852.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/135ba686685a969ceb6946c5ac336c8f56f9ab81aa00d7c0dd3741f5daac7096.jpeg",
  ],
  priceDollars: 12.47,
  description:
    "We're excited to announce our latest collaboration with Rebecca Jane Woolbright! Together, we've created something truly special - reversible towels that feature two amazing prints for a unique and stylish look.\n\nWhether you're looking to add a pop of color to your kitchen or want to impress your guests with your impeccable taste, this towel is the perfect choice. Plus, they're made from our signature waffle (made from recycled bottles) that is both absorbent and quick dry, so they'll be a valuable addition to your home for years to come.",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:54.728Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
